import request from './service/index'

// designer 列表查询
export function getDesignerList_Api(data){//查询列表
    return request({
        url:'CMS/exhibition/designer_list',
        method:'post',
        data:data
    });
}

export function deleteDesignerList_Api(data){//删除列表
    return request({
        url:'CMS/exhibition/designer_list',
        method:'delete',
        data:data
    });
}

export function getDesignerDetail_Api(id){//设计师详情
    return request({
        url:`CMS/exhibition/designer_detail?designer_id=${id}`,
        method:'get',
    });
}

export function setDesignerDetail_Api(data){//设计师详情 set
    return request({
        url:'CMS/exhibition/designer_detail',
        method:'post',
        data:data
    });
}

export function updateDesignerDetail_Api(data){//设计师详情 update
    return request({
        url:'CMS/exhibition/designer_detail',
        method:'put',
        data:data
    });
}

export function deleteDesignerDetail_Api(data){//设计师详情 delete
    return request({
        url:'CMS/exhibition/designer_detail',
        method:'delete',
        data:data
    });
}

//Base 列表查询
export function getBaseList_Api(data){//查询列表
    return request({
        url:'CMS/exhibition/base_list',
        method:'post',
        data:data
    });
}

export function deleteBaseList_Api(data){//删除列表
    return request({
        url:'CMS/exhibition/base_list',
        method:'delete',
        data:data
    });
}

export function getBaseDetail_Api(id){//基地详情
    return request({
        url:`CMS/exhibition/base_detail?base_id=${id}`,
        method:'get',
    });
}

export function setBaseDetail_Api(data){//基地详情 set
    return request({
        url:'CMS/exhibition/base_detail',
        method:'post',
        data:data
    });
}

export function updateBaseDetail_Api(data){//基地详情 update
    return request({
        url:'CMS/exhibition/base_detail',
        method:'put',
        data:data
    });
}

export function deleteBaseDetail_Api(data){//基地详情 delete
    return request({
        url:'CMS/exhibition/base_detail',
        method:'delete',
        data:data
    });
}

//organization  列表查询
export function getOrganizationList_Api(data){//查询列表
    return request({
        url:'CMS/exhibition/organization_list',
        method:'post',
        data:data
    });
}

export function deleteOrganizationList_Api(data){//删除列表
    return request({
        url:'CMS/exhibition/organization_list',
        method:'delete',
        data:data
    });
}

export function getOrganizationDetail_Api(id){//机构详情
    return request({
        url:`CMS/exhibition/organization_detail?organization_id=${id}`,
        method:'get',
    });
}

export function setOrganizationDetail_Api(data){//机构详情 set
    return request({
        url:'CMS/exhibition/organization_detail',
        method:'post',
        data:data
    });
}

export function updateOrganizationDetail_Api(data){//机构详情 update
    return request({
        url:'CMS/exhibition/organization_detail',
        method:'put',
        data:data
    });
}

export function deleteOrganizationDetail_Api(data){//机构详情 delete
    return request({
        url:'CMS/exhibition/organization_detail',
        method:'delete',
        data:data
    });
}

export function getOrganizationSearch_Api(keyword){//查询
    return request({
        url:`CMS/tools/organization_search_box?keyword=${keyword}`,
        method:'get'
    })
}

//展馆
//展馆详情
export function getExhibitionList_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_list',
        method:'post',
        data:data
    });
}

export function deleteExhibitionList_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_list',
        method:'delete',
        data:data
    });
}

export function getExhibitionDetail_Api(id){
    return request({
        url:`CMS/exhibition/exhibition_detail?exhibition_id=${id}`,
        method:'get'
    });
}

export function setExhibitionDetail_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_detail',
        method:'post',
        data:data
    });
}

export function updateExhibitionDetail_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_detail',
        method:'put',
        data:data
    });
}

export function deleteExhibitionDetail_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_detail',
        method:'delete',
        data:data
    });
}

export function getExhibitionCount_Api(){
    return request({
        url:'CMS/exhibition/exhibition_count',
        method:'get',
    });
}

export function getWorksCount_Api(){
    return request({
        url:'CMS/exhibition/works_count',
        method:'get',
    });
}

export function organizationDropDown_Api(){
    return request({
        url:`/CMS/tools/organization_drop_down`,
        method:'get',
    })
}

export function baseDropDown_Api(){
    return request({
        url:`/CMS/tools/base_drop_down`,
        method:'get',
    })
}

export function exhibitionCompetitionDropDown_Api(){
    return request({
        url:`/CMS/tools/exhibition_competition_drop_down`,
        method:'get',
    })
}

export function exhibitionDropDown_Api(){
    return request({
        url:`/CMS/tools/exhibition_drop_down`,
        method:'get',
    })
}

export function designerDropDown_Api(){
    return request({
        url:`/CMS/tools/designer_drop_down`,
        method:'get',
    })
}

export function getExhibitionTop_Api(){
    return request({
        url:'CMS/exhibition/exhibition_top',
        method:'get',
    })
}

export function exhibitionTop_Api(data){
    return request({
        url:'CMS/exhibition/exhibition_top',
        method:'post',
        data:data
    })
}

export function getWorksList_Api(data){
    return request({
        url:'CMS/exhibition/works_list',
        method:'post',
        data:data
    })
}

export function deleteWorksList_Api(data){
    return request({
        url:'CMS/exhibition/works_list',
        method:'delete',
        data:data
    })
}

export function getWorksDetail_Api(id){
    return request({
        url:`CMS/exhibition/works_detail?works_id=${id}`,
        method:'get'
    });
}

export function setWorksDetail_Api(data){
    return request({
        url:'CMS/exhibition/works_detail',
        method:'post',
        data:data
    });
}

export function updateWorksDetail_Api(data){
    return request({
        url:'CMS/exhibition/works_detail',
        method:'put',
        data:data
    });
}

export function deleteWorksDetail_Api(data){
    return request({
        url:'CMS/exhibition/works_detail',
        method:'delete',
        data:data
    });
}

export function worksClassification_Api(page){
    return request({
        url:`CMS/exhibition/works_classification?page=${page}`,
        method:'get',
    });
}

export function getWorksClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_classification',
        method:'post',
        data:data
    });
}

export function updateWorksClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_classification',
        method:'put',
        data:data
    });
}

export function deleteWorksClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_classification',
        method:'delete',
        data:data
    });
}

export function worksCompetitionClassification_Api(page){
    return request({
        url:`CMS/exhibition/works_competition_classification?page=${page}`,
        method:'get',
    });
}

export function getWorksCompetitionClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_competition_classification',
        method:'post',
        data:data
    });
}

export function updateWorksCompetitionClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_competition_classification',
        method:'put',
        data:data
    });
}

export function deleteWorksCompetitionClassification_Api(data){
    return request({
        url:'CMS/exhibition/works_competition_classification',
        method:'delete',
        data:data
    });
}


// WEBPACK FOOTER //
// ./src/apis/exhibition.api.js